import moment from 'moment'

// Status mapping
export const STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'paused', label: 'Paused' },
  { value: 'not_opened', label: 'Not Opened' }
]

export const formatArcAdForApi = (values) => {
  const data = {
    type: 'arc_ads',
    attributes: {
      banner_id: values.banner_id,
      campaign_id: values.campaign_id,
      header: values.header,
      description: values.description,
      terms_url: values.terms_url,
      click_url: values.click_url,
      rule_id: values.rule_id,
      cta_text: values.cta_text,
      secondary_cta_text: values.secondary_cta_text,
      third_cta_text: values.third_cta_text,
      platform: values.platform?.value !== undefined ? values.platform.value : values.platform,
      status: values.status?.value || values.status,
      source: values.source_id?.value !== undefined ? values.source_id.value : values.source_id,
      footer_text: values.footer_text,
      footer_policy_text: values.footer_policy_text,
      footer_policy_url: values.footer_policy_url,
      started_at: values.started_at,
      end_at: values.end_at,
      hero_width: values.hero_width,
      hero_height: values.hero_height,
      icon_width: values.icon_width,
      icon_height: values.icon_height,
      logo_icon_width: values.logo_icon_width,
      logo_icon_height: values.logo_icon_height
    },
  }

  if (values.countries !== undefined) {
    data.attributes.countries = values.countries?.map(country => country.value || country) || []
  }

  if (values.allowed_domains !== undefined) {
    data.attributes.allowed_domains = values.allowed_domains?.map(domain => domain.value || domain) || []
  }

  if (values.categories !== undefined) {
    data.attributes.category_ids = values.categories || []
  }

  if (values.icon_url_base64) {
    data.attributes.icon_url_base64 = values.icon_url_base64
    data.attributes.icon_width = values.icon_width || 150
    data.attributes.icon_height = values.icon_height || 150
  }

  if (values.hero_url_base64) {
    data.attributes.hero_url_base64 = values.hero_url_base64
    data.attributes.hero_width = values.hero_width || 600
    data.attributes.hero_height = values.hero_height || 400
  }

  if (values.logo_icon_url_base64) {
    data.attributes.logo_icon_url_base64 = values.logo_icon_url_base64
    data.attributes.logo_icon_width = values.logo_icon_width || 120
    data.attributes.logo_icon_height = values.logo_icon_height || 34
  }


  return data
}

export const formatArcAdForForm = (ad, included = []) => {
  if (!ad) return {}

  return {
    id: ad.id,
    banner_id: ad.attributes.banner_id,
    campaign_id: ad.attributes.campaign_id,
    header: ad.attributes.header,
    description: ad.attributes.description,
    terms_url: ad.attributes.terms_url,
    click_url: ad.attributes.click_url,
    rule_id: ad.attributes.rule_id,
    cta_text: ad.attributes.cta_text,
    secondary_cta_text: ad.attributes.secondary_cta_text,
    third_cta_text: ad.attributes.third_cta_text,
    platform: ad.attributes.platform,
    icon_url: ad.attributes.icon_url,
    icon_width: ad.attributes.icon_width,
    icon_height: ad.attributes.icon_height,
    hero_url: ad.attributes.hero_url,
    hero_width: ad.attributes.hero_width,
    hero_height: ad.attributes.hero_height,
    logo_icon_url: ad.attributes.logo_icon_url,
    logo_icon_width: ad.attributes.logo_icon_width,
    logo_icon_height: ad.attributes.logo_icon_height,
    status: ad.attributes.status,
    source_id: ad.attributes.source,
    footer_text: ad.attributes.footer_text,
    footer_policy_text: ad.attributes.footer_policy_text,
    footer_policy_url: ad.attributes.footer_policy_url,
    started_at: ad.attributes.started_at,
    end_at: ad.attributes.end_at,
    countries: ad.attributes.countries || [],
    allowed_domains: ad.attributes.allowed_domains || [],
    category_ids: ad.attributes.category_ids || [],
    categories: ad.attributes.categories || []
  }
}

export const formatArcAdForTable = (ad, included = []) => {
  if (!ad) return {}

  // Find the campaign from included data
  const campaign = included?.find(item =>
    item.type === 'arc_campaigns' &&
    item.id.toString() === ad.attributes?.campaign_id.toString()
  )

  // Find the advertiser through the campaign relationship
  const advertiser = included?.find(item =>
    item.type === 'arc_advertisers' &&
    item.id === campaign?.relationships?.arc_advertiser?.data?.id
  )
  const isExpired = ad.attributes.end_at && moment().isAfter(moment(ad.attributes.end_at))


  return {
    key: ad.id,
    id: ad.id,
    header: ad.attributes.header,
    description: ad.attributes.description,
    cta_text: ad.attributes.cta_text,
    secondary_cta_text: ad.attributes.secondary_cta_text,
    third_cta_text: ad.attributes.third_cta_text,
    platform: ad.attributes.platform,
    icon_url: ad.attributes.icon_url,
    hero_url: ad.attributes.hero_url,
    logo_icon_url: ad.attributes.logo_icon_url,
    advertiser_name: advertiser?.attributes?.name || 'N/A',
    advertiser_id: advertiser?.id,
    status: ad.attributes.status,
    isExpired: isExpired,
    source: ad.attributes.source_id,
    source_name: ad.attributes.source,
    started_at: ad.attributes.started_at ? moment(ad.attributes.started_at).format('YYYY-MM-DD HH:mm') : 'N/A',
    end_at: ad.attributes.end_at ? moment(ad.attributes.end_at).format('YYYY-MM-DD HH:mm') : 'N/A',
    countries: ad.attributes.countries || [],
    allowed_domains: ad.attributes.allowed_domains || [],
    category_ids: ad.attributes.category_ids || [],
    categories: ad.attributes.categories || [],
    created_at: moment(ad.attributes.created_at).format('YYYY-MM-DD HH:mm'),
    updated_at: moment(ad.attributes.updated_at).format('YYYY-MM-DD HH:mm'),
  }
}